import { Box } from '@mui/material';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid-pro';

import { PanelGrid } from 'components/grid';
import { Block } from 'components/page';
import { SubTitle } from 'components/text';
import { ApuracaoLojasStatusFinalizadoErro } from 'pages/financeiro/reembolso/manutencao-reembolso/types';

/**
 * Retorna array com os dados formatados para o grid.
 */
const getRows = (data: ApuracaoLojasStatusFinalizadoErro[]): GridRowsProp => {
    const list = data;

    if (Array.isArray(list) && list.length) {
        return list.map((item) => ({
            id: item.idApuracaoLoja,
            cdLoja: item.loja.cdLoja,
            dsNomeFantasia: item.loja.dsNomeFantasia,
            dsValidacao: item.dsValidacao,
        }));
    }

    return [];
};

const columns: GridColDef[] = [
    {
        field: 'loja',
        headerName: 'Loja',
        flex: 1,
        sortable: false,
        renderCell: ({ row }) => `${row.cdLoja} - ${row.dsNomeFantasia}`,
    },
    {
        field: 'dsValidacao',
        headerName: 'Falha',
        flex: 3,
        sortable: false,
    },
];

export function ManutencaoReembolsoFalhasGrid({ falhas }: { falhas: ApuracaoLojasStatusFinalizadoErro[] }) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', p: 2 }}>
            <SubTitle label="Falhas" />

            <PanelGrid rows={getRows(falhas)} reload={false} remote={false} columns={columns} loading={false} />
        </Box>
    );
}
